import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetOrderPrioGetOrderPrioList = () =>
    request({
        url: ApiURL.Query.GetOrderPrioList,
        method: RequestType.GET,
    });

const GetOrderPrioTypes = () =>
    request({
        url: ApiURL.Query.GetOrderPrioTypes,
        method: RequestType.GET,
    });

const GetOrderPrioReasons = () =>
    request({
        url: ApiURL.Query.GetOrderPrioReasons,
        method: RequestType.GET,
    });

const OrderPrioQuery = {
    GetOrderPrioGetOrderPrioList,
    GetOrderPrioReasons,
    GetOrderPrioTypes,
};

export default OrderPrioQuery;
